<div class="notification-info">

  <h3>
    @if (!isExistingForm()) {
      <span>Create</span>
    }
    @if (isExistingForm()) {
      <span>Modify</span>
    }
    Notification
  </h3>

  @if (currentNotification()) {
    <div class="main-content">
      <div class="columns">
        <div class="column is-3">
          <span>Level</span>
        </div>
        <div class="column is-5 field">
          @if (isStudyNotification()) {
            <div>
              <span>Study</span>
            </div>
          }
          @if (!isStudyNotification()) {
            <div>
              <span>Group</span>
            </div>
          }
        </div>
        <div class="column"></div>
      </div>
      <div class="columns">
        <div class="column is-3">
          <span>Notification Name</span>
        </div>
        <div class="column is-5 field">
          <div class="control">
            <input [attr.disabled]="isNotificationTypeNotify() ? '' : null" placeholder="Notification Name" id="notification-name" name="notificationName" [(ngModel)]="currentNotification().name" class="input width-100-percent" [disabled] ="isGroupNav || !isEditable">
          </div>
        </div>
        <div class="column"></div>
      </div>
      @if (!isStudyNotification()) {
        <div class="columns">
          <div class="column is-3">
            <span>Group</span>
          </div>
          <div class="column is-5 field">
            <div class="control">
              <div class="select">
                <select [(ngModel)]="currentNotification().researchEntity" [compareWith]="this.compareFn" [disabled] ="isGroupNav || !isEditable">
                  <option value=null selected>-- Select --</option>
                  @for (gType of groupsList; track gType) {
                    <option [ngValue]="gType">
                      {{gType.name}}
                    </option>
                  }
                </select>
              </div>
            </div>
          </div>
          <div class="column"></div>
        </div>
      }
      <div class="columns">
        <div class="column is-3">
          <span>Status</span>
        </div>
        <div class="column is-5 field">
          <div class="control">
            <div class="select">
              <select [(ngModel)]="currentNotification().status" [compareWith]="this.compareFn" [disabled] ="isGroupNav || !isEditable">
                @for (sType of statusTypesList; track sType) {
                  <option [ngValue]="sType">
                    {{sType.value}}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="column"></div>
      </div>
    </div>
  }
</div>
